import ProductItem from './ProductItem';

export default {
  ProductItem,
};
